import { collectionGroup, getDocs, query, where } from "firebase/firestore";
import { useEffect, useState } from "react";

import { db } from "integrations/firebase/firestore";

import {
  membershipCardSchema,
  type MembershipCard,
} from "../dashboard/schemas";

export type AdminEventsState =
  | { status: "loading" }
  | { status: "error"; error: string }
  | { status: "success"; data: MembershipCard[] };

// A1: collection-group members where uid == me, filtered isEventAdmin in memory.
export function useAdminEvents(uid: string): AdminEventsState {
  const [state, setState] = useState<AdminEventsState>({ status: "loading" });

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        const snap = await getDocs(
          query(collectionGroup(db, "members"), where("uid", "==", uid)),
        );
        if (cancelled) return;

        const data: MembershipCard[] = [];
        snap.forEach((d) => {
          const result = membershipCardSchema.safeParse(d.data());
          if (result.success && result.data.isEventAdmin) {
            data.push(result.data);
          }
        });

        setState({ status: "success", data });
      } catch (err) {
        if (cancelled) return;
        setState({
          status: "error",
          error:
            err instanceof Error ? err.message : "Failed to load admin events",
        });
      }
    }

    void load();
    return () => {
      cancelled = true;
    };
  }, [uid]);

  return state;
}
